import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { CheckCircle2, Package } from "lucide-react";
import api from "@/lib/api";
import { formatINR } from "@/constants/branding";
import { Button } from "@/components/ui/button";

export default function OrderSuccess() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    api.get(`/orders/${id}`).then((r) => setOrder(r.data)).catch(() => {});
  }, [id]);

  return (
    <div className="shell max-w-2xl py-10 sm:py-16 text-center animate-fade-up">
      <div className="h-20 w-20 mx-auto mb-5 rounded-full bg-primary/10 flex items-center justify-center"><CheckCircle2 className="h-11 w-11 text-primary" /></div>
      <h1 className="font-display text-3xl sm:text-4xl font-bold text-deep">Order Placed Successfully!</h1>
      <p className="text-muted-foreground mt-2">Thank you for shopping with Zilkart. Your order is being processed.</p>

      {order && (
        <div className="mt-8 surface p-6 text-left" data-testid="order-success-summary">
          <div className="flex items-center justify-between pb-4 border-b border-border">
            <div>
              <p className="text-xs text-muted-foreground">Order Number</p>
              <p className="font-bold">{order.order_number}</p>
            </div>
            <span className="text-sm bg-primary/10 text-primary px-3 py-1 rounded-full capitalize">{order.status}</span>
          </div>
          <div className="py-4 space-y-2">
            {order.items.map((it) => (
              <div key={it.product_id} className="flex items-center gap-3 text-sm">
                <span className="h-12 w-12 shrink-0 rounded-lg bg-secondary overflow-hidden"><img src={it.image} alt={it.name} className="h-full w-full object-contain p-1 mix-blend-multiply" /></span>
                <span className="flex-1 truncate">{it.name} × {it.qty}</span>
                <span className="font-medium">{formatINR(it.line_total)}</span>
              </div>
            ))}
          </div>
          <div className="pt-4 border-t border-border flex items-center justify-between font-bold">
            <span>Total Paid ({order.payment_method.toUpperCase()})</span>
            <span>{formatINR(order.total)}</span>
          </div>
        </div>
      )}

      <div className="mt-8 flex flex-wrap gap-3 justify-center">
        <Button onClick={() => navigate("/account?tab=orders")} className="gap-2" data-testid="order-success-view-orders">
          <Package className="h-4 w-4" /> View My Orders
        </Button>
        <Button variant="outline" onClick={() => navigate("/products")}>Continue Shopping</Button>
      </div>
    </div>
  );
}
